'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactMotion = require('react-motion');

exports.default = _extends({}, _reactMotion.presets, {
  mid: {
    stiffness: 150,
    damping: 20
  },
  slow: {
    stiffness: 60,
    damping: 30
  },
  fast: {
    stiffness: 300,
    damping: 30
  },
  elastic: {
    stiffness: 150,
    damping: 5
  }
});
//# sourceMappingURL=spring.js.map